import { render } from "./Layout.vue?vue&type=template&id=28602988"
const script = {}
script.render = render

export default script